import { useTranslation } from 'react-i18next';
import { GoHomeButton, UserNavigationError } from '../components';

const Actions = <GoHomeButton variant="contained" />;

const Http403 = () => {
  const { t } = useTranslation();
  return (
    <UserNavigationError
      code={403}
      description={t('pages.Http403.description')}
      actions={Actions}
    />
  );
};

export default Http403;
